import { DoqType, ResponsiveDoqWithSpeechBubble } from '@ardoq/doq';
import { FlexBox, Stack } from '@ardoq/layout';
import { EmptyStatesDoqContainer } from '@ardoq/graph';
import { Notifier } from '@ardoq/dropdown-menu';
import { t, type I18nLocale } from '@ardoq/i18n';
import { i18nLocale$ } from 'streams/i18nLocale$';
import { connect } from '@ardoq/rxbeach';
import { map } from 'rxjs';

type NoSelectedColumnDoqProps = {
  doqType: DoqType;
  includeActions?: boolean;
  selectColumnAction?: Notifier;
  i18nLocale: I18nLocale;
};

const NoSelectedColumnDoqBase = ({
  doqType,
  includeActions = true,
  selectColumnAction,
  i18nLocale,
}: NoSelectedColumnDoqProps) => {
  return (
    <EmptyStatesDoqContainer>
      <ResponsiveDoqWithSpeechBubble
        doqType={doqType}
        title={t(
          i18nLocale,
          'tabview:graphViews.emptyState.noSelectedColumn.title',
          'There is nothing to show'
        )}
        message={
          <Stack gap="xlarge">
            <FlexBox gap="medium">
              {t(
                i18nLocale,
                'tabview:graphViews.emptyState.noSelectedColumn.message1',
                'All columns are currently hidden.'
              )}
            </FlexBox>
            <FlexBox gap="medium">
              {t(
                i18nLocale,
                'tabview:graphViews.emptyState.noSelectedColumn.message2',
                'To show more data, select at least one column.'
              )}
            </FlexBox>
          </Stack>
        }
        buttonLabel={
          includeActions
            ? t(
                i18nLocale,
                'tabview:graphViews.emptyState.noSelectedColumn.selectColumn',
                'Select column'
              )
            : undefined
        }
        onButtonClick={
          includeActions && selectColumnAction
            ? () => selectColumnAction.notify()
            : undefined
        }
      />
    </EmptyStatesDoqContainer>
  );
};
export const NoSelectedColumnDoq = connect(
  NoSelectedColumnDoqBase,
  i18nLocale$.pipe(map(i18nLocale => ({ i18nLocale })))
);
